import api from './api';
import { API_ENDPOINTS } from '../constants';
import { UserDocument } from '../types';

export interface CreateUserDocumentRequest {
  document_type: string;
  document_name: string;
  description?: string;
}

const userDocumentService = {
  getByUser: async (userId: string): Promise<UserDocument[]> => {
    const res = await api.get<{ success: boolean; data: UserDocument[] }>(
      API_ENDPOINTS.USER_DOCUMENTS.LIST_BY_USER(userId)
    );
    return res.data.data;
  },

  createForUser: async (
    userId: string,
    payload: CreateUserDocumentRequest,
    files: File[]
  ): Promise<UserDocument> => {
    const form = new FormData();
    form.append('document_type', payload.document_type);
    form.append('document_name', payload.document_name);
    if (payload.description) form.append('description', payload.description);
    files.forEach((f) => form.append('documents', f));

    const res = await api.post<{ success: boolean; data: UserDocument }>(
      API_ENDPOINTS.USER_DOCUMENTS.CREATE_FOR_USER(userId),
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return res.data.data;
  },
};

export default userDocumentService;


